export const dateFormat = (date)=>{
    return (new Date(date)).toLocaleDateString('fr-FR',{year: 'numeric', month: 'short', day: 'numeric'})
} 